import Link from '../../components/framework/link'
import React from 'react'
import { Container } from '../../components/ui/container'
import { ACTIONS, SITE } from '../../config/site'

/**
 * Slim navy bar above the header. It carries credibility and the two
 * contractor-facing links, which keeps them out of the main navigation.
 *
 * It scrolls away with the page — only the header below it is sticky.
 */
export function AnnouncementBar() {
  return (
    <div className="bg-navy text-[0.8125rem] leading-none text-white">
      <Container>
        <div className="flex h-9 items-center justify-center nav:justify-between">
          {/* Narrow viewports get one short line rather than a squeezed row. */}
          <p className="text-white/80 nav:hidden">{SITE.taglineShort}</p>

          <p className="hidden text-white/80 nav:block">{SITE.tagline}</p>

          <div className="hidden items-center gap-3 nav:flex">
            <Link
              href={ACTIONS.forContractors.href}
              className="focus-on-navy rounded-sm text-white/80 motion-micro hover:text-white"
            >
              {ACTIONS.forContractors.label}
            </Link>
            <span className="h-3 w-px bg-white/20" aria-hidden="true" />
            <Link
              href={ACTIONS.myBusiness.href}
              className="focus-on-navy rounded-sm text-white/80 motion-micro hover:text-white"
            >
              {ACTIONS.myBusiness.label}
            </Link>
            <span className="h-3 w-px bg-white/20" aria-hidden="true" />
            <Link
              href={ACTIONS.listBusiness.href}
              className="focus-on-navy rounded-sm font-semibold text-orange motion-micro hover:text-orange-hover"
            >
              {ACTIONS.listBusiness.label}
            </Link>
          </div>
        </div>
      </Container>
    </div>
  )
}
